{
  "toast": {
    "analyticsRefreshed": "Analytique refreshed",
    "ruleSaved": "Rule enregistré",
    "ruleRemoved": "Règle removed",
    "postRescheduled": "Publication rescheduled",
    "campaignCreated": "Campaign créé",
    "submittedForApproval": "Submitted pour approbation",
    "channelConnectedSuccessfully": "Canal connected successfully",
    "channelAddedFinishConnectionBelow": "Channel ajoutered — finish connection below",
    "connectedDemoMode": "Connected (demo mode)",
    "disconnected": "Disconnected",
    "channelDeleted": "Canal deleted permanently",
    "reconnectStarted": "Reconnect started",
    "replyPublished": "Reply published",
    "commentResolved": "Commentaire resolved",
    "assigned": "Assigned",
    "replySent": "Réponse envoyée",
    "conversationAssigned": "Conversation assigned",
    "escalatedDeskTicketWorkflowTriggered": "Escalated — Desk ticket flux de travail triggered",
    "noteSavedForYourTeam": "Note enregistré pour votre team",
    "savedReplyAdded": "Saved reply ajoutered",
    "inboundMessageSimulated": "Inbound message simulated",
    "published": "Published",
    "connectedInDemoModeRunTestsBelow": "Connected in demo mode — run tests below",
    "allTestsPassed": "All tests passed",
    "diagnosticsComplete": "Diagnostic complete",
    "tokenRefreshAttempted": "Jeton refresh attempted",
    "notificationPreferencesSaved": "Notification preferences enregistré",
    "keywordAdded": "Keyword ajoutered",
    "folderCreated": "Folder créé",
    "folderDeleted": "Dossier supprimé",
    "uploadComplete": "Upload complete",
    "assetRemoved": "Actif removed",
    "publishRetryCompleted": "Publish retry terminé",
    "publishedToConnectedChannels": "Published à connected channels",
    "reviewIngestedSimulatedWebhook": "Avis ingested (simulated webhook)",
    "brandCreated": "Brand créé",
    "competitorAdded": "Competitor ajoutered",
    "integrationCredentialsSaved": "Integration credentials enregistré",
    "connectionFlowReset": "Configuration form reset",
    "reportExported": "{{reportType}} exporté",
    "leadCreated": "Prospect n°{{id}} créé",
    "noteAdded": "Note ajoutée",
    "tagCreated": "Étiquette créée",
    "conversationEscalated": "Conversation escaladée",
    "scheduled": "Planifié",
    "workflowSaved": "Flux enregistré",
    "connectionValidated": "Connexion validée",
    "postScheduled": "Publication planifiée"
  },
  "errors": {
    "analyticsUnavailable": "Analytique indisponible",
    "syncFailed": "Échec de la synchronisation",
    "failedToLoadDashboard": "Impossible de charger les indicateurs du tableau de bord. Actualisez ou vérifiez vos autorisations.",
    "exportFailed": "Échec de l'export",
    "failedToLoadAutomationRules": "Échec du chargement de automation rules",
    "failedToSaveRule": "Échec de l'enregistrement de rule",
    "failedToDeleteRule": "Échec : delete rule",
    "failedToUpdateRule": "Échec de la mise à jour de rule",
    "calendarUnavailableOnCurrentPlan": "Calendar unavailable on forfait actuel",
    "rescheduleFailed": "Échec de reschedule",
    "failedToCreateCampaign": "Échec de la création de campaign",
    "approvalSubmitFailed": "Échec de approval submit",
    "accountNameIsRequired": "Account name is requis",
    "couldNotAddChannel": "Impossible de add channel",
    "connectionFailedSeeSetupGuideForThisNetwork": "Connection failed — see setup guide pour ce network",
    "disconnectFailed": "Échec de disconnect",
    "deleteChannelFailed": "Échec : delete canal",
    "reconnectFailed": "Échec de reconnect",
    "failedToLoadComments": "Échec du chargement de comments",
    "replyFailed": "Échec de l'envoi de la réponse",
    "resolveFailed": "Échec de resolve",
    "assignFailed": "Échec de l'assignation",
    "couldNotCreateCrmLead": "Impossible de create CRM lead",
    "selectAConnectedAccount": "Sélectionnez un connected account",
    "recipientPhoneRequired": "Saisissez le numéro du destinataire au format E.164 (sans +) pour les envois WhatsApp test",
    "recipientPhoneInvalid": "Le numéro doit être indicatif + numéro (ex. 33612345678), chiffres uniquement",
    "failedToLoadInbox": "Échec du chargement de inbox",
    "failedToLoadMessages": "Échec du chargement de messages",
    "failedToSendMessage": "Échec : send message",
    "assignmentFailed": "Échec de assignment",
    "escalationFailed": "Échec de escalation",
    "couldNotSaveNote": "Impossible de save note",
    "simulationFailed": "Échec de simulation",
    "failedToLoadPosts": "Échec du chargement de posts",
    "publishFailed": "Échec de publish",
    "connectChannelFirst": "Connectez d'abord un canal",
    "connectionFailed": "Échec de connection",
    "testsFailed": "Échec de tests",
    "failedToLoadAccounts": "Échec du chargement de accounts",
    "failedToLoadConnectionCenter": "Échec du chargement de connection center",
    "diagnosticsFailed": "Échec de diagnostics",
    "tokenRefreshFailedReconnectChannel": "Jeton refresh failed — reconnect canal",
    "reconnectChannelPrompt": "This channel needs à be reconnected à continue.",
    "addKeywordFailed": "Échec de add keyword",
    "failedToLoadFolders": "Échec du chargement de folders",
    "failedToCreateFolder": "Échec de la création de folder",
    "uploadFailed": "Échec du téléversement",
    "deleteFailed": "Échec de la suppression",
    "contentAndAtLeastOnePlatformRequired": "Content et at least one platform requis",
    "createFailed": "Échec de la création",
    "mediaFileTooLarge": "Le fichier média est trop volumineux (max 100 MB)",
    "scheduleMustBeFuture": "Schedule time must be in le future",
    "publishFailedUseRetryAfterFixingChannelTokens": "Publish failed — utiliser Retry after fixing channel tokens",
    "retryFailedOpenConnectionCenterToRefreshTokens": "Échec de la nouvelle tentative — ouvrez le Centre de connexion pour actualiser les jetons",
    "contentIsRequired": "Content is requis",
    "selectAtLeastOneConnectedChannel": "Sélectionnez au moins un connected channel",
    "selectAConnectedChannel": "Sélectionnez un connected channel",
    "failedToReply": "Échec : reply",
    "failedToCreateBrand": "Échec de la création de brand",
    "failedToAddKeyword": "Échec de l'ajout de keyword",
    "failedToAddCompetitor": "Échec de l'ajout de competitor",
    "failedToSaveIntegration": "Échec de l'enregistrement de integration",
    "resetConnectionFailed": "Échec : reset connection setup",
    "failedToLoadTeam": "Échec du chargement de team",
    "failedToLoadCampaigns": "Échec du chargement de campaigns",
    "failedToLoadCrmLeads": "Échec du chargement de cRM leads",
    "listeningUnavailableOnCurrentPlan": "Listening unavailable on forfait actuel",
    "failedToLoadMediaLibrary": "Échec du chargement de media library",
    "failedToLoadStorage": "Échec du chargement du résumé de stockage",
    "failedToDeleteFolder": "Échec de suppression du dossier",
    "failedToLoadPublishing": "Échec du chargement de publishing",
    "failedToLoadReviews": "Échec du chargement de reviews",
    "failedToAddNote": "Échec de l'ajout de la note",
    "failedToCreateTag": "Échec de la création de l'étiquette",
    "failedToUpdateFavorite": "Échec de la mise à jour du favori",
    "couldNotLoadMediaAsset": "Impossible de charger le média",
    "failedToSaveWorkflow": "Échec de l'enregistrement du flux",
    "failedToSavePreferences": "Échec de l'enregistrement des préférences",
    "failedToStartAuthorization": "Échec du démarrage de l'autorisation",
    "validationFailed": "Échec de la validation",
    "failedToUpdateConnectionProgress": "Échec de la mise à jour de la progression de connexion"
  },
  "pages": {
    "followersAudience": "Followers / audience",
    "reach": "Reach",
    "engagement": "Engagement",
    "messages": "Messages",
    "responseTime": "Temps de réponse",
    "clicks": "Clics",
    "impressions": "Impressions",
    "leadAttribution": "Attribution des prospects",
    "liveMonitoring": "Surveillance en direct",
    "topContent": "Meilleur contenu",
    "analyticsCenter": "Centre d'analyse",
    "rankedByEngagementFromSyncedSnapshots": "Ranked by engagement de synced snapshots",
    "crossPlatformPerformanceExportsAndScheduled": "Cross-platform performance, exports, et scheduled rapporting",
    "automationCenter": "Automation Center",
    "autoRepliesAssignmentLeadRoutingReview": "Auto-replies, assignment, lead routing, review routing, escalation, et sentiment rules — magasind securely per organization",
    "contentCalendar": "Calendrier de contenu",
    "dragPostsBetweenDaysToReschedule": "Drag posts between days à reschedule — auto-publish runs every 30 seconds",
    "socialCampaigns": "Campagnes sociales",
    "crossChannelCampaignsLinkedToMarketing": "Cross-channel campaigns linked à Marketing — no duplicate campaign engine",
    "connectedChannels": "Canaux connectés",
    "addSocialAccount": "Add compte social",
    "addMultiplePagesAccountsOrLocations": "Add multiple Pages, accounts, ou locations per network under one login",
    "commentsCenter": "Centre de commentaires",
    "replyAssignResolveAndConvertFacebook": "Reply, assign, resolve, et convert Facebook, Instagram, LinkedIn, X, et YouTube comments à CRM leads",
    "engagementTrends": "Tendances d'engagement",
    "platformComparison": "Comparaison des plateformes",
    "responsePerformance": "Performance de réponse",
    "crossChannelActivityOverTime": "Cross-canal activity over time",
    "engagementAndClicksByChannel": "Engagement et clicks by channel",
    "averageResponseTimeTrendMinutes": "Average temps de réponse trend (minutes)",
    "writtenForBusinessOwnersAndMarketing": "Written pour business owners et marketing teams — no technical background requis",
    "socialConnectionCenter": "Social Centre de connexion",
    "connected": "Connecté",
    "avgHealth": "Avg health",
    "tokenIssues": "Jeton issues",
    "webhookIssues": "Webhook issues",
    "connectValidateAndMonitorEverySocial": "Connect, validate, et monitor every social channel — no developer knowledge requis",
    "connectAccount": "Connect compte",
    "resetConnection": "Réinitialiser",
    "resetConnectionTitle": "Reset configuration form?",
    "resetConnectionMessage": "This will clear le setup wizard progress et remove enregistré app credentials pour {{platform}}. Votre already connected channels will pas be disconnected.",
    "resetConnectionConfirm": "Réinitialiser",
    "deleteChannelTitle": "Delete canal",
    "deleteChannelMessage": "Supprimer définitivement « {{name}} » et toutes les conversations, publications, commentaires et données de connexion associés ? Cette action est irréversible.",
    "deleteChannelPermanently": "Delete canal permanently",
    "resetSharedMetaCredentialsWarning": " Saved Meta app credentials will also be removed (shared avec Facebook, Instagram, WhatsApp, et Threads). Connected channels stay linked.",
    "resetSharedGoogleCredentialsWarning": " Saved Google app credentials will also be removed (shared avec YouTube et Google Business). Connected channels stay linked.",
    "crmLeadsFromSocial": "CRM Leads de Social",
    "leadsCreatedFromInboxCommentsReviews": "Leads créé de inbox, comments, reviews, et intake automation",
    "socialCommandCenter": "Tableau de bord",
    "getStarted": "Commencer",
    "getStartedDescription": "Connectez Facebook, Instagram, WhatsApp, LinkedIn et plus — vous pouvez ajouter plusieurs comptes par réseau.",
    "addFirstAccount": "Ajouter votre premier compte",
    "publishingCenterLink": "Centre de publication →",
    "notConnected": "Non connecté",
    "areasCount": "{{count}} zones",
    "additionalMetrics": "Indicateurs supplémentaires",
    "comments": "Commentaires",
    "reviews": "Avis",
    "leadsGenerated": "Prospects generated",
    "publishedPosts": "Publications publiées",
    "channelHealth": "Santé du canal",
    "openComments": "Commentaires ouverts",
    "todaySWork": "Today's work",
    "connectedPlatforms": "Connected platforms",
    "unifiedSocialInboxPublishingAndAnalytics": "Unified social inbox, publishing, et analytics pour votre connected accounts",
    "openADedicatedWorkspaceOnlySupported": "Open a dedicated workspace — only supported features appear",
    "refreshData": "Actualiser les données",
    "refreshingData": "Actualisation…",
    "dashboardChartsEmpty": "L'activité s'affichera ici au fil des messages, publications et commentaires.",
    "dashboardChannelsEmpty": "Connectez des canaux pour comparer l'engagement par plateforme.",
    "dashboardResponseEmpty": "Les tendances de temps de réponse apparaissent après les réponses de l'équipe.",
    "unifiedInbox": "Boîte de réception unifiée",
    "allChannels": "All canaux",
    "facebookInstagramWhatsappTelegramAndAll": "Facebook, Instagram, WhatsApp, Telegram, et all messaging-capable channels in one queue",
    "socialListening": "Écoute sociale",
    "brandKeywordAndHashtagMatchesAcross": "Brand, keyword, et hashtag matches across connected channels",
    "mediaLibrary": "Médiathèque",
    "imagesVideosAndCampaignAssetsOrganized": "Images, videos, et campaign assets — organized in folders avec search et reuse in Publishing",
    "status": "Statut",
    "publishing": "Publication",
    "notAvailable": "Not disponible",
    "stories": "Stories",
    "reels": "Reels",
    "mentions": "Mentions",
    "publishingCenter": "Centre de publication",
    "composePost": "Compose publication",
    "composeScheduleApproveAndPublishAcross": "Compose, schedule, approve, et publish across connected networks",
    "imagesOrVideoForThisPost": "Images ou video pour ce post",
    "createPost": "Create publication",
    "multiChannelPostsWithSchedulingMedia": "Multi-channel posts avec scheduling, media, et provider delivery",
    "imagesVideoOrPdf": "Images, video, ou PDF",
    "socialAnalytics": "Social Analytique",
    "followers": "Followers",
    "channelPerformanceMonitoringAndCsvExports": "Channel performance, monitoring, et CSV exports",
    "reviewsCenter": "Avis Center",
    "totalReviews": "Total avis",
    "open": "Open",
    "replied": "Replied",
    "avgRating": "Avg rating",
    "googleAndFacebookReviewsReplyAssign": "Google et Facebook reviews — reply, assign, track sentiment, et convert à CRM leads",
    "socialSettings": "Social Paramètres",
    "apiKeysWebhooksBrandsAndShortcuts": "API keys, webhooks, brands, et shortcuts à platform workspaces. Connect channels in Connection Center.",
    "socialSetup": "Social Configuration",
    "platformCredentialsMultiBrandListeningAnd": "Platform credentials, multi-brand, listening, et competitor tracking",
    "socialTeams": "Social Teams",
    "assignConversationsAndModerateContentBy": "Assign conversations et moderate content by team member",
    "socialWebhooks": "Social webhooks",
    "configureMetaLinkedinAndOtherNetworks": "Configure Meta, LinkedIn, et other networks à POST inbound events",
    "connectPlatform": "Connecter {{platform}}",
    "followEachStepToConnectChannel": "Suivez chaque étape pour connecter votre canal.",
    "useConvertToLeadOnAnyMessage": "Utilisez Convertir en prospect sur tout message, commentaire ou avis. L'attribution utilise la source de prospect"
  },
  "labels": {
    "ruleName": "Nom de la règle",
    "campaignName": "Nom de la campagne",
    "network": "Réseau",
    "displayName": "Nom affiché",
    "accountIdOptional": "Compte ID (facultatif)",
    "status": "Statut",
    "assignTo": "Assign to",
    "assignAgent": "Assign agent…",
    "writeAPublicReply": "Write a public reply…",
    "simulateInboundDemo": "Simulate inbound (demo)",
    "recipientPhone": "Numéro du destinataire (E.164, sans +)",
    "recipientPhoneHint": "ex. 33612345678 — laisser vide pour un fil de démo",
    "message": "Message",
    "typeAReply": "Type a reply…",
    "teamOnlyNoteNotSentTo": "Team-only note (not sent à client)…",
    "sectionTabs": "Section tabs",
    "publishing": "Publication",
    "inboxDm": "Boîte de réception / DM",
    "comments": "Commentaires",
    "reviews": "Avis",
    "analytics": "Analytique",
    "crmIntegration": "CRM intégration",
    "selectChannel": "Select canal",
    "addKeyword": "Add mot-clé",
    "newFolder": "New dossier",
    "searchByNameOrTag": "Search by name ou tag…",
    "folders": "Dossiers",
    "allAssets": "Tous les médias",
    "uploadAssets": "Téléverser des médias",
    "uploading": "Téléversement…",
    "uploadProgress": "Téléversé {{done}} sur {{total}}",
    "storageUsed": "Stockage utilisé",
    "readyAssets": "Médias prêts",
    "processingAssets": "En cours",
    "rejectedAssets": "Rejetés",
    "allStatuses": "Tous les statuts",
    "statusReady": "Prêt",
    "statusProcessing": "En cours",
    "statusRejected": "Rejeté",
    "gridView": "Grille",
    "listView": "Liste",
    "loading": "Chargement…",
    "noAssetsYet": "Aucun média pour le moment. Téléversez des images, vidéos, audios ou documents pour les réutiliser.",
    "noUsableAssets": "Aucun média utilisable. Téléversez des fichiers dans la médiathèque et attendez qu'ils soient prêts.",
    "video": "Vidéo",
    "audio": "Audio",
    "document": "Document",
    "fileName": "Nom du fichier",
    "type": "Catégorie",
    "size": "Taille",
    "actions": "Opérations",
    "title": "Titre",
    "content": "Contenu",
    "schedule": "Planification",
    "mediaAttachment": "Media attachment",
    "optionalMediaFile": "Facultatif media file",
    "scheduleOptional": "Planification (facultatif)",
    "mediaOptional": "Media (facultatif)",
    "attachMediaToThisPost": "Attach media à ce post",
    "simulateReviewDemo": "Simulate avis (demo)",
    "reviewText": "Avis text",
    "rating": "Note",
    "writeAReply": "Write a reply…",
    "platform": "Platform",
    "appIdClientId": "App ID / Client ID",
    "appSecret": "App secret",
    "webhookVerifyToken": "Webhook verify jeton",
    "profileName": "Profile name",
    "brandName": "Brand name",
    "keywordOrHashtag": "Keyword ou #hashtag",
    "newRule": "Nouvelle règle",
    "allPlatforms": "Toutes les plateformes",
    "active": "Actif",
    "paused": "En pause",
    "slaBreached": "SLA dépassé",
    "internalNotes": "Notes internes",
    "conversationActions": "Actions de conversation",
    "assignConversation": "Assigner la conversation",
    "addANote": "Ajouter une note...",
    "tags": "Étiquettes",
    "newTag": "Nouvelle étiquette",
    "slaStatus": "Statut SLA",
    "due": "Échéance",
    "conversationBreachedSla": "Cette conversation a dépassé son SLA.",
    "platformIntegrationLiveOauth": "Intégration de plateforme (OAuth en direct)",
    "platformIntegrationDescription": "Chaque organisation utilise ses propres identifiants d'application. Rien n'est partagé depuis les valeurs serveur par défaut. Enregistrez les identifiants ici avant de connecter les canaux dans le centre de connexion.",
    "savedInDatabase": "Enregistré en base de données",
    "appId": "ID d'application",
    "webhookToken": "Jeton webhook",
    "wabaId": "ID WABA",
    "businessId": "ID Business",
    "botToken": "Jeton du bot",
    "configured": "Configuré",
    "updatedAt": "Mis à jour le {{date}}",
    "saved": "Enregistré",
    "leaveBlankToKeepExistingSecret": "Laisser vide pour conserver le secret existant",
    "whatsappBusinessAccountId": "ID du compte WhatsApp Business (WABA)",
    "numericWabaIdFromMetaBusinessManager": "ID WABA numérique depuis Meta Business Manager",
    "metaBusinessIdOptional": "ID Meta Business (facultatif)",
    "botTokenFromBotfather": "Jeton du bot (depuis BotFather)",
    "leaveBlankToKeepExistingToken": "Laisser vide pour conserver le jeton existant",
    "required": "requis",
    "demo": "démo",
    "brands": "Marques",
    "listeningKeywords": "Mots-clés d'écoute",
    "competitors": "Concurrents",
    "followersCount_one": "{{count}} abonné",
    "followersCount_other": "{{count}} abonnés",
    "done": "Terminé",
    "source": "Origine",
    "score": "Score",
    "customer": "Client",
    "all": "Tous",
    "resolved": "Résolu",
    "repliedWithText": "Répondu : {{text}}",
    "preview": "Aperçu",
    "matched": "Correspondance",
    "template": "Modèle",
    "body": "Corps",
    "channels": "Canaux",
    "teamMember": "Membre de l'équipe",
    "email": "E-mail",
    "role": "Rôle",
    "socialPermissions": "Autorisations sociales",
    "time": "Heure",
    "action": "Opération",
    "detail": "Détail"
  },
  "formActions": {
    "save": "Enregistrer",
    "saveCredentials": "Enregistrer les identifiants",
    "saveDraftOrSchedule": "Enregistrer le brouillon / planifier",
    "publishWithMedia": "Publier avec média",
    "publishNow": "Publier maintenant",
    "cancel": "Annuler",
    "close": "Fermer",
    "continue": "Continuer",
    "back": "Retour"
  },
  "listActions": {
    "newPost": "Nouvelle publication",
    "calendar": "Calendrier",
    "openMediaLibrary": "Ouvrir la médiathèque",
    "trackCompetitor": "Suivre un concurrent",
    "sendTestMessage": "Envoyer un message test",
    "simulateWebhook": "Simuler le webhook",
    "exportPosts": "Exporter les publications",
    "exportInbox": "Exporter la boîte de réception",
    "refreshData": "Actualiser les données",
    "refreshToken": "Actualiser le jeton",
    "checkConnectionHealth": "Vérifier l'état de la connexion",
    "openPublishingCenter": "Ouvrir le centre de publication",
    "addAccount": "Ajouter un compte",
    "addAnotherAccount": "Ajouter un autre compte",
    "addAndConnect": "Ajouter et connecter",
    "compose": "Rédiger",
    "archive": "Archiver",
    "unarchive": "Désarchiver",
    "escalate": "Escalader",
    "tag": "Étiquette",
    "assign": "Assigner",
    "add": "Ajouter",
    "create": "Créer",
    "addRule": "Ajouter une règle",
    "pause": "Mettre en pause",
    "activate": "Activer",
    "delete": "Supprimer",
    "favorite": "Ajouter aux favoris",
    "unfavorite": "Retirer des favoris",
    "clear": "Effacer",
    "apply": "Appliquer",
    "publish": "Publier",
    "retry": "Réessayer",
    "pickFromLibrary": "Choisir dans la médiathèque",
    "openWorkspace": "Ouvrir l'espace de travail",
    "openInCrm": "Ouvrir dans le CRM",
    "fullCrm": "CRM complet →",
    "resolve": "Résoudre",
    "addChannel": "Ajouter un canal",
    "refreshStatus": "Actualiser le statut",
    "fix": "Corriger →",
    "reconnect": "Reconnect",
    "connectAPlatform": "Connecter une plateforme",
    "previous": "Précédent",
    "next": "Suivant",
    "refreshAccess": "Actualiser l'accès",
    "readGuide": "Lire le guide",
    "guidedReconnect": "Reconnexion guidée"
  },
  "empty": {
    "noNotesYet": "Aucune note pour le moment.",
    "noSlaDeadline": "Aucune échéance SLA définie pour cette conversation.",
    "noAutomationRulesYet": "Aucune règle d'automatisation pour le moment.",
    "noBrandsEnterpriseMultiBrand": "Aucune marque (multi-marque Enterprise)",
    "noKeywordsConfigured": "Aucun mot-clé configuré",
    "noCompetitorsTracked": "Aucun concurrent suivi",
    "noLogEntriesYet": "Aucune entrée de journal pour le moment.",
    "noDrafts": "Aucun brouillon",
    "noPostsInQueue": "Aucune publication dans la file",
    "noSocialSourcedLeadsYet": "Aucun prospect issu des réseaux sociaux pour le moment.",
    "noPostCommentsYet": "Aucun commentaire de publication pour le moment. Ils apparaissent quand les webhooks se synchronisent ou quand vous simulez un engagement entrant.",
    "noListeningMatchesYet": "Aucune correspondance pour le moment. Ajoutez des mots-clés dans la configuration ; les correspondances apparaissent quand les plateformes se synchronisent ou quand vous simulez une activité entrante.",
    "noWhatsappTemplatesFound": "Aucun modèle trouvé. Connectez WhatsApp dans le centre de connexion.",
    "noChannelsYet": "Aucun canal pour le moment.",
    "noAuditEntriesYet": "Aucune entrée d'audit pour le moment."
  },
  "loading": {
    "rules": "Chargement des règles...",
    "comments": "Chargement des commentaires…"
  },
  "inbox": {
    "views": {
      "all": "Boîte unifiée",
      "unread": "Non lus",
      "assigned": "Assignés",
      "archived": "Archivés"
    },
    "filters": {
      "title": "Filtres",
      "filterConversations": "Filtrer les conversations",
      "allStatuses": "Tous les statuts"
    },
    "status": {
      "closed": "Fermé"
    }
  },
  "publishing": {
    "tabs": {
      "compose": "Composer",
      "drafts": "Brouillons",
      "queue": "File de publication",
      "logs": "Journaux de publication",
      "media": "Médiathèque",
      "approvals": "Approbations"
    },
    "table": {
      "platforms": "Plateformes"
    },
    "partialFallback": "Publié sur certains canaux seulement. Consultez les journaux de publication et réessayez les canaux en échec.",
    "mediaLibraryHint": "Téléversez et réutilisez des images et vidéos dans la médiathèque dédiée.",
    "connectPublishingChannelsHint": "Connectez des canaux compatibles avec la publication dans les paramètres. WhatsApp est réservé à la boîte de réception.",
    "mediaPreview": "Aperçu du média",
    "platformSelection": "Sélection des plateformes",
    "scheduleHint": "Laissez la planification vide pour publier immédiatement. Définissez une date et une heure pour mettre la publication en file.",
    "connectAtLeastOneChannel": "Connectez au moins un canal avant de publier."
  },
  "workflow": {
    "title": "Concepteur de flux",
    "description": "Concevez des automatisations en plusieurs étapes avec déclencheurs, conditions et actions.",
    "viewRules": "Voir les règles",
    "blocks": "Blocs",
    "workflowName": "Nom du flux",
    "trigger": "Déclencheur",
    "action": "Opération",
    "replyText": "Texte de réponse",
    "canvasPreview": "Aperçu du canevas",
    "triggers": {
      "inboundMessage": "Message entrant",
      "whatsappMessage": "Message WhatsApp",
      "commentReceived": "Commentaire reçu"
    },
    "actions": {
      "autoReply": "Réponse automatique",
      "assignAgent": "Assigner un agent",
      "setPriority": "Définir la priorité"
    }
  },
  "automation": {
    "triggers": {
      "inboundMessage": "Message entrant",
      "newComment": "Nouveau commentaire",
      "newReview": "Nouvel avis",
      "negativeSentiment": "Sentiment négatif"
    },
    "actions": {
      "autoReply": "Réponse automatique",
      "assignAgent": "Assigner un agent",
      "createCrmLead": "Créer un prospect CRM",
      "escalate": "Escalader"
    }
  },
  "platformOptions": {
    "meta": "Meta (Facebook / Instagram / WhatsApp / Threads)",
    "google": "Google (YouTube + Google Business)",
    "linkedin": "LinkedIn",
    "twitter": "X (Twitter)",
    "tiktok": "TikTok",
    "telegram": "Bot Telegram",
    "pinterest": "Pinterest",
    "facebook": "Facebook",
    "instagram": "Instagram",
    "whatsapp": "WhatsApp"
  },
  "platforms": {
    "whatsapp": {
      "templatesDescription": "Modèles de messages WhatsApp approuvés synchronisés depuis votre WABA connecté."
    }
  },
  "teams": {
    "permissionsSummary": "Boîte de réception · Publication · Analytique (via les rôles de l'organisation)",
    "assignmentHint": "L'assignation est disponible dans la boîte de réception unifiée et les boîtes des plateformes. Gérez les rôles sous Organisation → Utilisateurs."
  },
  "connection": {
    "tabs": {
      "connect": "Connecter",
      "connectedChannels": "Canaux connectés",
      "setupGuide": "Guide de configuration",
      "connectionHealth": "État de la connexion"
    },
    "activeAlerts": "Alertes actives",
    "tokenStatus": "Statut du jeton",
    "valid": "Valide",
    "expiredOrMissing": "Expiré / manquant",
    "expires": "Expire",
    "refreshToken": "Jeton d'actualisation",
    "present": "Présent",
    "missing": "Manquant",
    "scopes": "Portées",
    "defaultDemo": "Par défaut / démo",
    "runAllTests": "Exécuter tous les tests",
    "runDiagnosticsEmpty": "Exécutez les diagnostics pour voir les résultats.",
    "logsPageSummary": "Page {{page}} · {{count}} entrées",
    "alertPreferences": "Préférences d'alerte",
    "notifications": {
      "emailOnTokenExpiry": "E-mail quand le jeton expire ou va bientôt expirer",
      "emailOnWebhookFailure": "E-mail en cas d'échec du webhook",
      "emailOnDisconnect": "E-mail en cas de perte de connexion",
      "inAppAlerts": "Notifications dans l'application"
    },
    "notificationDeliveryHint": "L'envoi des e-mails utilise les paramètres de notification de votre organisation. Les alertes dans l'application apparaissent sur le tableau de bord Social.",
    "noActiveIssuesPrefix": "Aucun problème de connexion actif. Pour des corrections étape par étape, ouvrez les",
    "setupGuidesLink": "guides de configuration",
    "whatToDo": "Que faire :",
    "oauth": "OAuth",
    "token": "Jeton",
    "webhook": "Webhook",
    "events24h": "Événements 24 h"
  },
  "settings": {
    "tabs": {
      "integrations": "Intégrations",
      "webhooks": "Webhooks",
      "brands": "Marques",
      "platforms": "Espaces de travail des plateformes",
      "advanced": "Avancé"
    },
    "platformWorkspace": "Espace de travail {{platform}} →",
    "connectionNotifications": "Notifications de connexion",
    "notifications": {
      "emailOnTokenExpiry": "E-mail à l'expiration du jeton",
      "emailOnWebhookFailure": "E-mail en cas d'échec du webhook",
      "emailOnDisconnect": "E-mail en cas de perte de connexion",
      "inAppAlerts": "Alertes dans l'application"
    },
    "diagnosticsAndLogs": "Diagnostics et journaux",
    "runConnectionTestsAndViewLogs": "Exécutez les tests de connexion et consultez les journaux depuis la vue d'état du centre de connexion ou les actions du canal.",
    "openConnectionHealth": "Ouvrir l'état de connexion",
    "outboundWebhooks": "Webhooks sortants",
    "configureOutboundEventSubscriptions": "Configurez les abonnements aux événements sortants via l'API ou les outils d'administration."
  }
}
